import React, {useState, useEffect} from 'react'
import {httpGet, httpPost} from '../shared/Config';
import {Button} from 'reactstrap';

import { useTranslation } from 'react-i18next';
import SimpleModal from "../shared/SimpleModal";
import InputSelect from "../shared/InputSelect";
import InputText from "../shared/InputText";

function AdminChange({isOpen, onCancel, onSaved, orgId, user}) {

    const {t} = useTranslation();

    const [description, setDescription] = useState();
    const [clientRoles, setClientRoles] = useState([]);
    const [newRole, setNewRole] = useState();
    const [working, setWorking] = useState(false);

    useEffect(() => {
        async function getClientRoles() {
            const clientRolesResponse = await httpGet(`/orgs/firmamex/clientRoles`);
            if(clientRolesResponse.data) {
                setClientRoles(clientRolesResponse.data.clientRoles.map((clientRole) => <option key={clientRole.id} value={clientRole.clientRole}>{t(clientRole.clientRole)}</option>));
                for(let clientRole of clientRolesResponse.data.clientRoles) {
                    if(clientRole.clientRole === user.adminCore) {
                        setNewRole(clientRole.clientRole);
                        setDescription(clientRole.clientRole+"_DESC");
                    }
                }
            
            }
            setWorking(false);
        }
        if(user) {
            setWorking(true);
            getClientRoles();
        }
    }, [isOpen]);

    function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
        onSaved(user, newRole);
    }

    function handleAdminChange(e) {
        e.preventDefault();
        e.stopPropagation();
        // Change description
        setNewRole(e.target.value);
        setDescription(e.target.value+"_DESC");
    }

    function handleCancel() {
        onCancel(user, newRole);
    }

    return (
        <SimpleModal isOpen={isOpen}>
            <form onSubmit={handleSubmit}>
                <h3>
                    {t('CHANGE_ROLE')}
                </h3> 
                {
                    user != null ? <React.Fragment>
                        <p>
                            {t('CHANGE_ROLE_DESC')}
                        </p>
                        <span>{t('CURRENT_USER')}<b>{user.email}</b></span>
                        <br/>
                        <span>{t('CURRENT_USER_ROLE')}<b>{t(user.adminCore)}</b></span>
                        <br/><br/>
                        <span style={{marginTop: '10px'}}>
                            <b>{t(description)}</b>
                        </span>
                        <div className="form-control">
                            <label className="label cursor-pointer">
                                <InputSelect
                                    disabled={clientRoles.length === 0}
                                    value={newRole}
                                    onChange={(e) =>handleAdminChange(e)}>
                                    <option value="NO_ROLE">{t('NO_ROLE')}</option>
                                    {clientRoles}
                                </InputSelect>
                            </label>
                        </div>
                        <div className={'modal-action'}>
                            <Button disabled={working || newRole === user.adminCore} type="submit" color="primary">{t('SAVE')}</Button>
                            <Button color="secondary" onClick={handleCancel}>{t('CANCEL')}</Button>
                        </div>
                    </React.Fragment> : null
                }
            </form>
        </SimpleModal>
    )
}

export default AdminChange;
